import { FC, useState } from 'react';
import { DateTime } from 'luxon';
import { Button, CircularProgress } from '@mui/material';
import PaymentTooltip from './Tooltip';
import BookDateOrderModal from 'src/pages/Order/Modal/BookDate';
import ArticlesModal from '../../../CartData/Modal';
import { useActions } from 'src/hooks/useActions';
import { useTypedSelector } from 'src/hooks/useTypeSelector';
import { dineroSubtractAmount } from 'src/common/utils/dataFormat';
import { IOrderFetch } from 'src/models/IOrder';
import './styles.scss';

interface IProps {
  order: IOrderFetch;
  isStripeId: boolean;
}

const PaymentsEditOrder: FC<IProps> = ({ order, isStripeId }) => {
  const { id, price, currency, partial_paid, start_date } = order;

  const { getDuePayment } = useActions();
  const { role } = useTypedSelector(state => state.auth);
  const isLoadingCharge = useTypedSelector(state => state.order.isLoading.charge);

  const due = dineroSubtractAmount(price, partial_paid!, currency);
  const daysToTripStart = DateTime.fromISO(start_date).diffNow('days').days;

  const [openCommon, setOpenCommon] = useState(false);
  const [openArticles, setOpenArticles] = useState(false);

  const handlePay = () => {
    getDuePayment(id, DateTime.now().toISO() < start_date ? 'due_payment' : 'afterCharge_payment');
  };

  return (
    <>
      {(role === 'admin' || role === 'super_host' || isStripeId) && (
        <div className='payment-extras'>
          <div className='payment-extras__title'>
            Settle Extras After Trip:
            <PaymentTooltip />
          </div>
          <div className='payment-extras__subtitle'>
            <div>
              Fix date/time&nbsp;
              <span onClick={() => setOpenCommon(true)}>Here.</span>
            </div>
            <div>
              Add service, fuel, tolls in&nbsp;
              <span onClick={() => setOpenArticles(true)}>Articles</span>
            </div>
          </div>
          <div className='payment-extras__buttons'>
            <Button
              onClick={handlePay}
              disabled={due <= 0 || daysToTripStart > 2 || isLoadingCharge}
            >
              {isLoadingCharge ? (
                <CircularProgress size={15} />
              ) : (
                <div>
                  <h3>Charge & email receipt</h3>
                  <p>Don’t overdue: Charge-backs</p>
                </div>
              )}
            </Button>
          </div>
        </div>
      )}
      <BookDateOrderModal handleClose={() => setOpenCommon(false)} open={openCommon} />
      <ArticlesModal open={openArticles} handleClose={() => setOpenArticles(false)} order={order} />
    </>
  );
};

export default PaymentsEditOrder;
